'use client';

import { cn, TToggleSwitchProps } from 'types';

export const ToggleSwitch = (props: TToggleSwitchProps) => {
  const { toggleHandler, checked = false, label, disabled = false, id, className = '', toggleClassName = '' } = props;

  const handleToggle = () => {
    if (!disabled) {
      const newState = !checked;
      toggleHandler(newState);
    }
  };

  return (
    <div className={cn('flex items-center gap-3', { 'cursor-not-allowed': disabled }, className)}>
      <label className="relative inline-block h-[1.5rem] w-[2.5rem] cursor-pointer">
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={handleToggle}
          disabled={disabled}
          className="h-0 w-0 opacity-0"
        />

        <span
          className={cn(
            'absolute inset-0 rounded-full transition-all duration-200',
            {
              'bg-darkBlue hover:bg-ultramarine': checked && !disabled,
              'bg-neutralPlus hover:bg-concrete': !checked && !disabled,
              'bg-neutralGrey cursor-not-allowed': disabled,
            },
            toggleClassName
          )}
        >
          <span
            className={cn(
              'absolute top-1/2 -translate-y-1/2 h-5 w-5 rounded-full bg-white shadow-md transition-all duration-200',
              checked ? 'left-[calc(100%-1.37rem)]' : 'left-[0.12rem]'
            )}
          />
        </span>
      </label>

      {label && (
        <label
          htmlFor={id}
          className={cn('font-semibold leading-[175%]', {
            'text-neutralPlus cursor-not-allowed': disabled,
            'cursor-pointer text-black': !disabled,
          })}
          onClick={handleToggle}
        >
          {label}
        </label>
      )}
    </div>
  );
};
